import React, { useEffect, useState } from 'react'
import { Navigation } from '../../features/Navigation/Navigation'
import { ReactComponent as BurgerMenu } from '@/shared/assets/desktop/burgerIcon.svg'
import { ReactComponent as CloseMenu } from '@/shared/assets/desktop/closeBtn.svg'
import logo from '@/shared/assets/logo.webp'
import cls from './Header.module.scss'
import useResize from '@/shared/lib/hooks/useResize'
import { classNames } from '@/shared/lib/utils/classNames'
import { scrollIntoView } from '@/shared/lib/utils/scrollIntoView'
import { useScrollDirection } from '@/shared/lib/hooks/useSrollDirection'
import { ContactForm } from '../ContactForm/ContactForm'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Select } from '@/shared/ui/Select/Select'

export const Header = () => {
    const { t, i18n } = useTranslation()
    const [selectedLang, setLang] = useState('en')
    const windowWidth = useResize()
    const scrollDirection = useScrollDirection()
    const location = useLocation()
    const navigate = useNavigate()
    const [menuOpen, setMenu] = useState(false)
    const [open, setOpen] = useState(false)
    const langHandler = (lang) => {
        setLang(lang)
        i18n.changeLanguage(lang)
    }
    const desktopHeader = () => {
        return (
            <header className={cls.Header}>
                <img
                    onClick={() => {
                        window.location.href = 'https://stellar-bets.com/'
                    }}
                    className={cls.logo}
                    src={logo}
                    alt="logo"
                />
                <Navigation />
                <Select
                    title={selectedLang}
                    selected={selectedLang}
                    setValue={langHandler}
                    options={['en', 'fi']}
                />
                <button
                    onClick={() => {
                        setOpen(true)
                    }}
                    className={cls.ContactUsButton}
                >
                    {t('navigation.contactus')}
                </button>
            </header>
        )
    }

    useEffect(() => {
        window.addEventListener('scroll', () => setMenu(false))

        return () => {
            window.removeEventListener('scroll', () => setMenu(false))
        }
    })

    const mobileHeader = () => {
        return (
            <>
                <header className={cls.mobileHeader}>
                    <img
                        onClick={() => {
                            if (location.path === '/') {
                                scrollIntoView('home')
                            } else {
                                navigate('/')
                                scrollIntoView('home')
                            }
                        }}
                        alt="some problems"
                        src={logo}
                        className={cls.logo}
                    />
                    {menuOpen ? (
                        <CloseMenu onClick={() => setMenu(false)} />
                    ) : (
                        <BurgerMenu
                            className={cls.BurgerIcon}
                            onClick={() => setMenu(true)}
                        />
                    )}
                </header>
                <div
                    className={classNames(cls.menu, [], {
                        [cls.close]: menuOpen === false,
                    })}
                >
                    <Navigation />
                    <button
                        onClick={() => {
                            setOpen(true)
                        }}
                        className={cls.ContactUsButton}
                    >
                        {t('navigation.contactus')}
                    </button>
                    <Select
                        title={selectedLang}
                        selected={selectedLang}
                        setValue={langHandler}
                        options={['en', 'fi']}
                    />
                </div>
            </>
        )
    }
    return (
        <>
            <ContactForm
                open={open}
                setOpen={setOpen}
            />
            <div
                className={classNames(cls.wrapper, [], {
                    [cls.close]: scrollDirection === 'down',
                })}
            >
                {windowWidth > 1023 ? desktopHeader() : mobileHeader()}
            </div>
        </>
    )
}
